export default __webpack_public_path__ + "static/media/scan_qr.1049e2a6.svg";